import { ExternalLink } from "lucide-react";
import { ListRow } from "@/components/ui/list-row";
import type { LearnerSessionMaterial } from "@/lib/api/sessionPortal";
import { materialIcon, materialKind } from "./session-material";

/** A material's title: the way in when the server opened it, its name otherwise. */
export function MaterialTitle({ title, href }: { title: string; href: string | null }) {
  if (!href) return <span className="text-ui font-semibold text-foreground [overflow-wrap:anywhere]">{title}</span>;
  return (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="-my-3 inline-flex min-h-11 items-center gap-1 py-3 text-ui font-semibold text-foreground underline-offset-2 hover:underline [overflow-wrap:anywhere]"
    >
      {title}
      <ExternalLink aria-hidden className="size-3 shrink-0 text-muted-foreground" />
      <span className="sr-only"> (opens in a new tab)</span>
    </a>
  );
}

/**
 * One material for a learner: what kind of thing it is, what it is called, and
 * one way in. `open_material` is the server's permission and `file_url` the
 * server's address; a material the server did not open still names itself.
 */
export function LearnerMaterialRow({ material }: { material: LearnerSessionMaterial }) {
  const canOpen = material.actions.includes("open_material") && material.file_url;
  const kind = materialKind(material);
  return (
    <ListRow icon={materialIcon(material)} data-record-id={material.id}>
      <MaterialTitle title={material.title} href={canOpen ? material.file_url : null} />
      {kind && <p className="text-meta text-muted-foreground">{kind}</p>}
    </ListRow>
  );
}
